export enum Direction {
  LONG = 'LONG',
  SHORT = 'SHORT',
}

export const DirectionLabels: Record<Direction, string> = {
  [Direction.LONG]: 'Long',
  [Direction.SHORT]: 'Short',
};
